import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export interface StandImportStats {
  agencies: { new: number; updated: number };
  decorators: { new: number; updated: number };
  exhibitors: { new: number; updated: number };
  stands: { created: number; total: number; updated: number };
}

export default class StandImportModel extends ApiModel {
  static get path() {
    return '/backend/stand_imports/{?id}';
  }

  @computed
  get stats(): StandImportStats {
    return this.get('stats');
  }
}
